document.addEventListener("DOMContentLoaded", () => {
  const sortTagsSelect = document.querySelector("#SortTags");
  const sortBySelect = document.querySelector("#SortBy");

  if (sortTagsSelect) {
    sortTagsSelect.addEventListener("change", () => {
      const selectedValue = sortTagsSelect.value;
      if (selectedValue) {
        window.location.href = selectedValue;
      }
    });
  }

  if (sortBySelect) {
    sortBySelect.addEventListener("change", () => {
      const selectedValue = sortBySelect.value;
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("sort_by", selectedValue);
      window.location.href = currentUrl.toString();
    });
  }
});